import InputField from '../inputs/InputField';
import { connect } from 'react-redux';
import { blur, change } from './actions';
import { questionKey } from '../response/reducer';

const mapStateToProps = (state, ownProps) => {
  const question = state[questionKey(ownProps)];
  return {
    isValid: question.isValid || question.fieldValids[ownProps.index],
    value: question.values[ownProps.index].value,
  };
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  onChange: e =>
    dispatch(change(e.target.value, ownProps.index, ownProps.questionId)),
  onBlur: () => dispatch(blur(ownProps.index, ownProps.questionId)),
});

const Blank = connect(mapStateToProps, mapDispatchToProps)(InputField);

export default Blank;
